import { useMutation } from "@tanstack/react-query";
import { noop } from "lodash";

import { MutationKeys } from "constants/mutation-keys";
import { ApiManager } from "services/api";
import TransactionSerializer from "services/api/transactions/transaction-serializer";

interface ILogoUpload {
  file: File;
  templateID?: string;
}
enum LogoUploadError {
  INTERNAL_ERROR = "INTERNAL_ERROR",
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const createTransaction = async (payload: { templateID?: string }) => {
  const { templateID } = payload;
  const { result, error } = await ApiManager.transactionApi.create(
    // @ts-expect-error TS2345
    templateID === "" ? { type: "templateLogo" } : { templateID, type: "templateLogo" }
  );
  if (error) {
    throw Error(LogoUploadError.INTERNAL_ERROR);
  }
  return result;
};

const uploadAttachment = async (payload: {
  transactionId: string;
  file: File;
  onSuccessFn: (transactionId: string) => void;
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
}) => {
  const { transactionId, file, onSuccessFn } = payload;
  const { result, error } = await ApiManager.transactionApi.uploadAttachment(file, transactionId, noop, noop);
  if (error) {
    throw Error(LogoUploadError.INTERNAL_ERROR); // todo: add more elaborate error handling
  }
  onSuccessFn(transactionId);
  // @ts-expect-error TS7053
  return result[0].url;
};

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function useLogoUpload(onSuccessFn: (transactionID: string) => void) {
  return useMutation({
    mutationKey: [MutationKeys.LogoUpload],
    mutationFn: async (payload: ILogoUpload) => {
      const { file, templateID } = payload;
      const transaction = await createTransaction({ templateID });
      return uploadAttachment({ transactionId: TransactionSerializer.deserialize(transaction).id, file, onSuccessFn });
    },
  });
}
